<template>
  <tg-button
    :classes="['tg-btn--clear']"
    round
    icon="times"
    @click.native="clickHandler"
  >{{$t('component.btn.clear')}}</tg-button>
</template>

<script>
import TgButton from "@/components/button/TgButton";

export default {
  components: {
    TgButton
  },
  name: "TgClearBtn",
  methods: {
    clickHandler(event) {
      this.$emit("click", event);
    }
  }
};
</script>
